import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';

import * as productApi from '../../lib/api/product';
import { finishLoading, startLoading } from '../loading';

const [
  LIST_PRODUCTS_PRICE,
  LIST_PRODUCTS_PRICE_SUCCESS,
  LIST_PRODUCTS_PRICE_FAILURE,
] = createRequestActionTypes('product/LIST_PRODUCTS_PRICE');
export const listProductsPrice = createAction(
  LIST_PRODUCTS_PRICE,
  (searchData) => searchData,
);
const listProductsPriceSaga = createRequestSaga(
  LIST_PRODUCTS_PRICE,
  productApi.getProductPriceListByVendor,
);

// function * listProductsPriceSaga(actions){
//   yield put(startLoading(LIST_PRODUCTS_PRICE));

//   try{
//     const res = yield call(productApi.getProductsForPrice, actions.payload);

//     if(res.data.list){

//       _.map(res.data.list, product =>{
//         let prices = JSON.parse(product.priceJson);
//         product.priceUuid = prices[0]['priceUuid'];
//         // product.priceVal = prices[0]['priceVal'];
//         // product.priceTyp = prices[0]['priceTyp'];

//       })
//     }

//     yield put({
//       type: LIST_PRODUCTS_PRICE_SUCCESS,
//       payload: {
//        list:res.data.list,
//       },
//     });

//   }catch(e){
//     yield put({
//       type: LIST_PRODUCTS_PRICE_FAILURE,
//       payload: e,
//       error: true,
//     });
//   }

//   yield put(finishLoading(LIST_PRODUCTS_PRICE));
// }

const UNLOAD_PRODUCTS_PRICE = 'product/UNLOAD_PRODUCTS_PRICE';
export const unloadProductsPrice = createAction(UNLOAD_PRODUCTS_PRICE);

export function* productsPriceSaga() {
  yield takeLatest(LIST_PRODUCTS_PRICE, listProductsPriceSaga);
}

const initialState = {
  products: null,
  error: null,
};

const productsPrice = handleActions(
  {
    [LIST_PRODUCTS_PRICE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      products:
        data.list &&
        data.list.map((product) => ({
          id: product.priceUuid,
          productUuid: product.productUuid,
          productNm: product.productNm,
          modelNm: product.modelNm,
          partnerUuid: product.partnerUuid,
          partnerNm: product.partnerNm,
          category: product.category,
          priceUuid: product.priceUuid,
          pricePartnerUuid: product.pricePartnerUuid,
          pricePartnerNm: product.pricePartnerNm,
          priceTyp: product.priceTyp,
          priceVal: product.priceVal,
          price: product.price,
          productDesc: product.productDesc,
          productUnit: product?.productUnit,
        })),
      error: null,
    }),
    [LIST_PRODUCTS_PRICE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PRODUCTS_PRICE]: () => initialState,
  },
  initialState,
);

export default productsPrice;
